/* eslint-disable import/no-extraneous-dependencies */
import React, { useCallback } from 'react';
import Timepicker from '@ott/timepicker';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import styles from './CarsTimepicker.scss';

function CarsTimepicker({ change, name, ...rest }) {
  const handleTimeSelectChange = useCallback(
    (filedName) => (time) => {
      change(filedName, time);
    },
    [change]
  );

  return (
    <Field
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      component={Timepicker}
      name={name}
      props={{
        isRelativePosition: true,
        onTimeSelect: handleTimeSelectChange(name),
        classNames: { ...rest.classNames, overlayContainer: styles.roundCorders },
      }}
    />
  );
}

CarsTimepicker.propTypes = {
  change: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default CarsTimepicker;
